import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormArray, FormBuilder, FormGroup } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { Subject } from "rxjs";
import { LookupModel } from "src/app/franchise-creation/models/models";
import { LookupService } from "src/app/services/LookupService";
import { DatepickerGregorianComponent } from "src/app/shared/components/datepicker-gregorian/datepicker-gregorian.component";
import { DatepickerUmalquraComponent } from "src/app/shared/components/datepicker-umalqura/datepicker-umalqura.component";
import { MomentTransformType } from "src/app/shared/models/enums";
import { IDate } from "src/app/shared/models/models";
import { MomentPipe } from "src/app/shared/pipes/moment.pipe";

@Component({
  selector: "app-filter",
  templateUrl: "./filter.component.html",
  styleUrls: ["./filter.component.scss"],
})
export class FilterComponent implements OnInit {
  @ViewChild("datePickerFromGregorian")
  datePickerFromGregorian: DatepickerGregorianComponent;
  @ViewChild("datePickerFromHijri")
  datePickerFromHijri: DatepickerUmalquraComponent;

  @ViewChild("datePickerToHijri")
  datePickerToHijri: DatepickerUmalquraComponent;
  @ViewChild("datePickerToGregorian")
  datePickerToGregorian: DatepickerGregorianComponent;
  @Output() public filterFormEvent: EventEmitter<any> = new EventEmitter<any>();
  requestGregStartDate: any;
  requestGregEndDate: any;
  filterForm: FormGroup;
  public regions: Array<LookupModel> | undefined = [];
  public cities: Array<LookupModel> | undefined = [];
  public selectedRegions: Array<any> = [];
  item: any;
  isHijriDate: boolean = false;
  private _error = new Subject<string>();
  errorMessage: string;
  constructor(
    private fb: FormBuilder,
    private lookupsService: LookupService,
    private translate: TranslateService,
    private momentPipe: MomentPipe
  ) {}

  ngOnInit(): void {
    this.getRegions();
    this.initFilterForm();
  }

  initFilterForm() {
    this.filterForm = this.fb.group({
      startDate: this.fb.control(null),
      endDate: this.fb.control(null),
      franchisRegion: this.fb.control(null),
      franchisCity: this.fb.control(null),
      tradeMarkName: this.fb.control(null),
      franchiseType: this.fb.group({
        MainCr: this.fb.control(false),
        MinorCr: this.fb.control(false),
      }),
      grantMechanism: this.fb.group({
        crDonor: this.fb.control(false),
        trademarkDonor: this.fb.control(false),
      }),
    });
  }
  get grantMechanismControls() {
    return (this.filterForm.get("grantMechanism") as FormArray).controls;
  }
  selectFranchiseStartDate(event: any) {
    if (this.isHijriDate) {
      this.filterForm.controls["startDate"].setValue(
        this.datePickerFromHijri.form.controls["date"].value
      );
    } else {
      this.filterForm.controls["startDate"].setValue(
        this.datePickerFromGregorian.form.controls["date"].value
      );
    }
  }

  selectFranchiseEndDate(event: any) {
    if (this.isHijriDate) {
      this.filterForm.controls["endDate"].setValue(
        this.datePickerToHijri.form.controls["date"].value
      );
    } else {
      this.filterForm.controls["endDate"].setValue(
        this.datePickerToGregorian.form.controls["date"].value
      );
    }
  }

  ongrantMechanismChange(event: any) {
    // this.filterForm.controls
  }

  onResetFilter() {
    if (this.isHijriDate) {
      this.datePickerFromHijri.form.controls["date"].setValue("");
      this.datePickerToHijri.form.controls["date"].setValue("");
    } else {
      this.datePickerFromGregorian.form.controls["date"].setValue("");
      this.datePickerToGregorian.form.controls["date"].setValue("");
    }
    this.isHijriDate = false;
    this.filterForm.reset();
    this.initFilterForm();
    const { startDate, endDate } = this.ParseDatesFromDatePickers(
      this.filterForm
    );
    let data = {
      form: this.filterForm,
      startDate: startDate,
      endDate: endDate,
    };
    this.filterFormEvent.emit(data);
  }

  onFilter() {
    const { startDate, endDate } = this.ParseDatesFromDatePickers(
      this.filterForm
    );
    if (startDate && endDate) {
      if (new Date(startDate) > new Date(endDate)) {
        this.errorMessage = "تاريخ البداية لابد ان يكون اقل من تاريخ النهاية";
        setTimeout(() => {
          this.errorMessage = ""; // Clear the error message after 3 seconds
        }, 3000);
        return;
      }
    }
    let data = {
      form: this.filterForm,
      startDate: startDate,
      endDate: endDate,
    };
    this.filterFormEvent.emit(data);
  }
  getRegions() {
    this.lookupsService.GetAdminRegions().subscribe(
      (data: any[]) => {
        this.regions = [];
        if (data && data.length > 0) {
          this.regions = data;
        }
      },
      (error) => {
        this.translate
          .get("ErrorCodes.RetrieveError")
          .subscribe((msg) => this._error.next(msg));
        console.log(error);
      }
    );
  }
  getCities(selectedRegions: any) {
    if (selectedRegions != undefined) {
      this.lookupsService.GetAdminCitiesByRegionsIds(selectedRegions).subscribe(
        (data: any[]) => {
          this.filterForm.setControl("franchisCity", this.fb.control(null));
          this.cities = [];
          this.cities = data;
        },
        (error) => {
          this.translate
            .get("ErrorCodes.RetrieveError")
            .subscribe((msg) => this._error.next(msg));
          console.log(error);
        }
      );
    }
  }
  regionChanged(data: any) {
    //convert single value to array in case the franchise isn't the main franchise
    if (!(data instanceof Array)) {
      data = [data];
    }
    if (data.length > 0 && data) {
      let arr = data.map((obj: { id: any }) => obj.id);
      this.getCities(arr);
    } else {
      this.filterForm.setControl("franchisCity", this.fb.control(null));
      this.cities = [];
    }
  }
  private ParseDatesFromDatePickers(event: FormGroup): {
    startDate: any;
    endDate: any;
  } {
    let ngsbDate: IDate = this.isHijriDate
      ? this.datePickerFromHijri.form.controls["date"].value
      : this.datePickerFromGregorian.form.controls["date"].value;

    let ngebDate = this.isHijriDate
      ? this.datePickerToHijri.form.controls["date"].value
      : this.datePickerToGregorian.form.controls["date"].value;

    let startDateString = !ngsbDate
      ? null
      : ngsbDate.year + "/" + ngsbDate.month + "/" + ngsbDate.day + " 10:00:00";
    let endDateString = !ngebDate
      ? null
      : ngebDate.year + "/" + ngebDate.month + "/" + ngebDate.day + " 10:00:00";

    if (this.isHijriDate) {
      let startDate = this.momentPipe.transform(
        startDateString,
        MomentTransformType.ToGregorianIsoStringFormatFromHijri
      );
      let endDate = this.momentPipe.transform(
        endDateString,
        MomentTransformType.ToGregorianIsoStringFormatFromHijri
      );
      return {
        startDate: startDate == "Invalid date" ? null : startDate,
        endDate: endDate == "Invalid date" ? null : endDate,
      };
    } else {
      let startDate = this.momentPipe.transform(
        startDateString,
        MomentTransformType.ToGregorianIsoStringFormat
      );
      let endDate = this.momentPipe.transform(
        endDateString,
        MomentTransformType.ToGregorianIsoStringFormat
      );
      return {
        startDate: startDate == "Invalid date" ? null : startDate,
        endDate: endDate == "Invalid date" ? null : endDate,
      };
    }
  }
}
